import { Injectable, inject } from "@angular/core";
import { Params } from "@angular/router";
import { Role } from "@vp/models";
import { UTILITY_OPTIONS } from "./tokens";

export interface RouterUtilityOptions {
  routeDefault: string;
}

@Injectable({
  providedIn: "root"
})
export class RouterUtilities {
  private options = inject<RouterUtilityOptions>(UTILITY_OPTIONS, { optional: true });

  static parseQueryString(search: string): Record<string, string | string[]> {
    return (search || "")
      .replace(/^\?/g, "")
      .split("&")
      .reduce(
        (acc, query) => {
          const [key, value] = query.split("=");
          if (!key) {
            return acc;
          }
          const decodedValue = decodeURIComponent(value);
          if (acc[key]) {
            acc[key] = Array.isArray(acc[key])
              ? [...(acc[key] as string[]), decodedValue]
              : [acc[key] as string, decodedValue];
          } else {
            acc[key] = decodeURIComponent(value);
          }
          return acc;
        },
        {} as Record<string, string | string[]>
      );
  }

  public getRouteDefaultFromRole(role: Role) {
    let path = this.options?.routeDefault;
    let queryParams: Params = {};
    if (role.routeDefault && role.routeDefault.path) {
      path = role.routeDefault.path as string;
    }
    if (role.routeDefault && role.routeDefault.queryParamData) {
      queryParams = role.routeDefault.queryParamData.reduce(
        (obj: Params, item: { key: string; value: string }) => ((obj[item.key] = item.value), obj),
        {}
      ) as Params;
    }
    return { path, queryParams };
  }
}
